export default "__VITE_ASSET__DsPwp2Jo__"